import React from 'react';

import Styled from './styles';

const handleKeyDown = (event) => {
  if (event.nativeEvent.keyCode === 39) { // ArrowRight
    if (event.target.nextSibling) {
      event.target.nextSibling.focus();
    } else {
      event.target.parentElement.firstChild.focus();
    }
  }
  if (event.nativeEvent.keyCode === 37) { // ArrowLeft
    if (event.target.previousSibling) {
      event.target.previousSibling.focus();
    } else {
      event.target.parentElement.lastChild.focus();
    }
  }
};

export interface CarouselIndicatorContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Container for CarouselIndicators, Consider using CarouselIndicator */
  children: React.ReactNode;
}

/** Should be nested in the `Carousel` component. All props will be provided to the root DOM element. */
const CarouselIndicatorContainer = (props: CarouselIndicatorContainerProps) => {
  const {
    children,
    ...otherProps
  } = props;

  return (
    <Styled.CarouselIndicatorContainer
      onKeyDown={handleKeyDown}
      {...otherProps}
    >
      {children}
    </Styled.CarouselIndicatorContainer>
  );
};
CarouselIndicatorContainer.displayName = 'CarouselIndicatorContainer';
export default CarouselIndicatorContainer;